<template>
    <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <div class="text-center">
                <div class="mb-0 flex justify-center">
                    <jet-application-mark class="h-9 w-auto" />
                </div>
            </div>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <div class="text-center">
                    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                        <p class="text-sm text-red-800">
                            <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="mr-2" />
                            This invitation is no longer valid.
                        </p>
                    </div>

                    <p class="text-sm text-gray-500">
                        Please contact the team administrator to request a new invitation.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    invitation: Object,
    cancelled: {
        type: Boolean,
        default: false
    }
});
</script>